export function migrateAuthStorage(): void {
  if (typeof window === 'undefined') return;

  const OLD_KEY = 'trade-bridge-auth-session';
  const NEW_KEY = 'bluechip-platform-auth';

  if (localStorage.getItem(NEW_KEY)) return;

  const existing =
    sessionStorage.getItem(OLD_KEY) ?? localStorage.getItem(OLD_KEY);

  if (existing) {
    localStorage.setItem(NEW_KEY, existing);
  }

  sessionStorage.removeItem(OLD_KEY);
  localStorage.removeItem(OLD_KEY);
}
